<template>
  <!-- 注销 -->
  <div id="cancelled">
    <div class="register-img">
      <img src="./images/组 2819.png" alt />
    </div>
    <!-- 代办优势 -->
    <div class="advantage">
      <h2 class="advantage-h2">中税代办注销优势</h2>
      <div class="advantage-items">
        <div class="item">
          <img src="./images/蒙版组 12.png" alt />
          <div class="item-text">
            <p>工商税务社保</p>
            <p>资深专员全流程代办</p>
          </div>
        </div>
        <div class="item">
          <img src="./images/蒙版组 39.png" alt />
          <div class="item-text">
            <p>注册税务师把关</p>
            <p>涉税疑难迎刃而解</p>
          </div>
        </div>
        <div class="item">
          <img src="./images/蒙版组 40.png" alt />
          <div class="item-text">
            <p>案例多经验足</p>
            <p>十年注销成功率百分百</p>
          </div>
        </div>
      </div>
    </div>
    <div></div>
    <!-- 公司注销流程 -->
    <div class="process">
      <h2 class="process-h2">公司注销流程</h2>
      <div class="process-link">
        <div class="process-imga">
          <img src="./images/路径 2898.png" alt />
        </div>
        <!-- 元素 -->
        <div class="process-item item1">
          <h3>登报公告</h3>
          <img src="./images/组 2820.png" alt />
        </div>
        <div class="process-item item2">
          <h3>账务清理</h3>
          <img src="./images/组 2821.png" alt />
        </div>
        <div class="process-item item3">
          <h3>税费清算</h3>
          <img src="./images/组 2822.png" alt />
        </div>
        <div class="process-item item4">
          <h3>税务注销</h3>
          <img src="./images/组 2823.png" alt />
        </div>
        <div class="process-item item5">
          <img src="./images/组 2823.png" alt />
          <h3>工商注销</h3>
        </div>
        <div class="process-item item6">
          <img src="./images/组 2825.png" alt />
          <h3>银行注销</h3>
        </div>
      </div>
    </div>
    <!-- 准备资料 -->
    <div class="quality">
      <h2 class="quality-h2">准备资料</h2>
      <!-- <p class="quality-p1">以上部分资料如有遗失，可作登报遗失公告等处理</p> -->
      <div class="quality-items">
        <div class="item">
          <div class="item-img">
            <img src="./images/组 2738.png" alt />
          </div>
          <p>近三年财务报表（注销年度最近一期报表、上年度、上上年度12月份报表）</p>
        </div>
        <div class="item">
          <div class="item-img">
            <img src="./images/组 2739.png" alt />
          </div>
          <p>公章、营业执照正副本</p>
        </div>
        <div class="item">
          <div class="item-img">
            <img src="./images/组 2740.png" alt />
          </div>
          <p>金税盘、发票本</p>
        </div>
        <div class="item">
          <div class="item-img">
            <img src="./images/组 2741.png" alt />
          </div>
          <p>近三年明细账、原始凭证</p>
        </div>
        <div class="item">
          <div class="item-img">
            <img src="./images/组 2742.png" alt />
          </div>
          <p>关于注销的股东会决议（可代拟文书）</p>
        </div>
      </div>
    </div>
    <!-- 注销成功案例 -->
    <div class="cancelled-case">
      <h1 class="cancelled-case-h2">注销成功 经典案例</h1>
      <div class="case-frame">
        <div class="frame-item">
          <div class="item-img">
            <img src="./images/VCG41N1020863554.png" alt="">
          </div>
          <div class="item-text">
            <h3>委托方所有企业资料遗失、系统内多年黑名单客户，成功注销</h3>
            <p>&emsp;&emsp;杭州王先生出国留学多年，回国创业，发现自己已被列入税务系统永久黑名单，无法设立新公司，原因系多年前创立过公司，但股东纠纷后，将公司弃之不管，导致公司成为工商和税务黑名单，同时殃及个人。委托方所有企业资料均已遗失，我公司接受委托，协助企业代拟各类注销文件，代办各种遗失公告，重新整理财务资料，代理与工商、税务机关进行沟通，帮助企业降低各环节成本，最后成功办结注销，获客户好评</p>
          </div>
        </div>
      </div>
      <div class="case-frame">
        <div class="frame-item">
          <div class="item-img">
            <img src="./images/蒙版组 12.png" alt="">
          </div>
          
          <div class="item-text">
            <h3>某企业不慎取得虚开的发票，被稽查，中税协助客户专业处理，减轻法律后果，事后成功注销</h3>
            <p>&emsp;&emsp;某电商企业，有天猫店，专注于经营，忽略财务重要性，低价进货，而且增值税进项税票来源不正规，后被金税三期系统发现，稽查介入，涉及补缴增值税、附加税费和企业所得税，金额巨大，寻求专业帮助。</p>
            <p>&emsp;&emsp;我公司注册税务师及代办团队结合客户实际情况，协助客户与主管税务机关进行发票善意取得辩护，帮助客户减轻法律后果，并在审核企业账务后，提出专业意见，合理合法降低企业补税成本。事后，成功注销企业，解决后患。</p>
          </div>
        </div>
      </div>
      <div class="case-frame">
        <div class="frame-item">
          <div class="item-img">
            <img src="./images/蒙版组 39.png" alt="">
          </div>
          <div class="item-text">
            <h3>财务人员不够专业负责，导致公司账面与实际情况不符，注销环节暴露大量涉税问题，协助成功解决并低税负完成注销</h3>
            <p>&emsp;&emsp;杭州某食品贸易企业，经营不善，拟注销。但是，截至注销日，公司账面尚余存货200万元，其他应收款900万元，应付账款100万元，其他应付款800万元，根据账面情况，该客户注销过程中涉及：存货处理应缴纳增值税、无需支付款项确认营业外收入、往来款长期挂账需计提利息收入等问题，账面问题涉各类税合计金额达250万元以上，但实际情况并非如此，许多账面情况与实际情况不相符，系历史原因以及会计做账失误导致。</p>
            <p>&emsp;&emsp;我公司通过专业团队分析判断并对历年账务追根溯源，对历史账务重新梳理，出具相关审计报告，并作为企业代表与税务机关进行沟通，解决上述所有问题，成功节约大量税金，帮助企业顺利注销。</p>
          </div>
        </div>
      </div>
      <div class="case-frame">
        <div class="frame-item">
          <div class="item-img">
            <img src="./images/蒙版组 40.png" alt="">
          </div>
          <div class="item-text">
            <h3>企业整体税收合规安排案例。某集团公司吸收合并子公司（有房产及土地），子公司注销环节涉及大量税金。我公司协助出具注销方案，以最低成本完成子公司注销及母公司吸收合并程序</h3>
            <p>&emsp;&emsp;某集团公司为公司整体发展考虑，拟对子公司进行吸收合并，该子公司被吸收合并后需要注销。由于子公司名下有房产及土地，合并过程中涉及大量税费。</p>
            <p>&emsp;&emsp;我公司建议集团公司利用税法规定的特殊性重组政策，对子公司进行吸收合并，协助客户制订整体重组方案，协助与主管税务机关及工商部门沟通整体流程及方案的落地，成功完成吸收合并工作，子公司顺利注销，整个流程几乎实现了零税负，客户十分满意。</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "cancelled",
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
.register-img {
  width: 100%;
  min-width: 1040px;
  img {
    width: 100%;
  }
}
// 代办优势
.advantage {
  width: 1040px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  // padding: 0 10%;
  box-sizing: border-box;
  padding-bottom: 50px;
  .advantage-h2 {
    padding: 30px 0;
  }
  .advantage-items {
    display: flex;
    justify-content: space-between;
    .item {
      width: 32%;
      box-sizing: border-box;
      img {
        width: 100%;
      }
      .item-text {
        width: 100%;
        box-sizing: border-box;
        text-align: center;
        padding: 20px 0;
        margin-right: -1px;
        border: 1px solid rgb(238, 238, 238);
        p {
          line-height: 25px;
          font-weight: 700;
        }
      }
    }
  }
}
// 注册流程
.process {
  width: 100%;
  min-width: 1040px;
  margin:0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 0;
  padding-bottom: 100px;
  box-sizing: border-box;
  background: rgb(241, 241, 241);
  .process-h2 {
    padding-bottom: 100px;
  }
  .process-link {
    width: 900px;
    position: relative;
    .process-imga {
      position: relative;
      width: 100%;
      img {
        width: 100%;
      }
    }
    .process-item {
      width: 60px;
      display: flex;
      justify-content: space-between;
      flex-direction: column;
      align-items: center;
      img {
        width: 100%;
      }
      h3 {
        margin-bottom: 20px;
      }
    }
    .item1 {
      position: absolute;
      top: -65px;
      left: -10px;
    }
    .item2 {
      position: absolute;
      top: -65px;
      left: 30%;
    }
    .item3 {
      position: absolute;
      top: -65px;
      right: 32%;
    }
    .item4 {
      position: absolute;
      top: -65px;
      right: 5%;
    }
    .item5 {
      position: absolute;
      bottom: -82px;
      right: 16%;
      h3 {
        margin-top: 20px;
      }
    }
    .item6 {
      position: absolute;
      bottom: -82px;
      right: 46%;
      h3 {
        margin-top: 20px;
      }
    }
  }
}
// 资料准备
.quality {
  // width: 100%;
  width: 1040px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  // padding: 0 15%;
  box-sizing: border-box;
  padding-bottom: 50px;
  .quality-h2 {
    padding-top: 30px;
    font-size: 20px;
    padding-bottom: 30px;
  }
  .quality-p1 {
    font-size: 16px;
    padding-bottom: 30px;
    color: rgb(119, 118, 118);
  }
  .quality-items {
    width: 100%;
    height: 180px;
    display: flex;
    justify-content: space-between;
    .item {
      width: 19%;
      display: flex;
      flex-direction: column;
      // justify-content: space-evenly;
      align-items: center;
      background-color: #fff;
      text-align: center;
      box-sizing: border-box;
      padding: 0 10px;
      box-shadow: 1px 1px 4px #dddddd;
      .item-img {
        margin-top: 30px;
        margin-bottom: 20px;
        width: 35%;
        font-size: 11px;
        img {
          width: 100%;
        }
      }
      p {
        flex: 0.8;
        display: flex;
        align-items: center;
      }
    }
  }
}

// 注销成功案例
.cancelled-case {
  // width: 100%;
  width: 1040px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  // padding: 0 15%;
  box-sizing: border-box;
  padding-bottom: 50px;
  .cancelled-case-h2 {
    padding-bottom: 20px;
    // font-size: 25px;
  }
  .case-frame {
    margin-bottom: 15px;
    .frame-item {
      width: 100%;
      padding: 30px;
      border: 1px solid #ccc;
      display: flex;
      box-sizing: border-box;
      .item-img {
        flex: 1;
        img {
          width: 95%
        }
      }
      .item-text {
        flex: 2;
        padding-left: 20px;
        display: flex;
        flex-direction: column;
        box-sizing: border-box;
        justify-content: center;
        h3 {
          margin-bottom: 5px;
          font-size: 16px;
        }
        p {
          line-height: 25px;
          font-size: 13px;
          color: #6f6f6f;
          font-size: 13px;
          line-height: 28px;
        }
      }
    }
  }

}
</style>


// WEBPACK FOOTER //
// src/components/inAndOut/cancelled/cancelled.vue